(function () {

    var $section = $('.contacts-top');

    if (!$section.length) return false;

    var $map = $section.find('[data-map]');
    var map;
    var latitude = parseFloat($map.attr('data-latitude'), 10);
    var longitude = parseFloat($map.attr('data-longitude'), 10);
    var zoom = parseInt($map.attr('data-zoom'), 10);
    var pin = $map.attr('data-pin');

    var pin_w, pin_h;

    var img = new Image();
    img.src = pin;

    var wait = setInterval(function () {
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        if (w && h) {
            pin_w = w;
            pin_h = h;
            clearInterval(wait);
            img = null;
        }
    }, 30);


    var render = function () {
        ymaps.ready(function () {

            map = new ymaps.Map($map[0], {
                center: [latitude, longitude],
                zoom: zoom,
                controls: ['zoomControl']
            }, {
                autoFitToViewport: 'always'
            });

            var marker = new ymaps.Placemark([latitude, longitude], {
                // hintContent: 'Собственный значок метки',
                // balloonContent: 'Это красивая метка'
            }, {
                iconLayout: 'default#image',
                iconImageHref: pin,
                iconImageSize: [pin_w, pin_h],
                iconImageOffset: [-pin_w / 2, -pin_h]
            });

            map.geoObjects.add(marker);

            map.behaviors.disable('scrollZoom');

            $map.addClass('map--loaded');
        });
    };

    var load = function () {
        $.getScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', function () {
            render();
        });
    };

    load();

})();
